module.exports = __webpack_public_path__ + "img/lunbo202.08951a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo202.png
// module id = RYiS
// module chunks = 0